import { getField, updateField } from 'vuex-map-fields';

export default {
  name: 'secondaryUserContext',
  namespaced: true,
  state: {
    isCustomer: '',
  },
  getters: {
    getField,
    userContext: (state) => state,
  },
  mutations: {
    updateField,
  },
};
